import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { FaCartShopping } from "react-icons/fa6";

// Utility function to combine class names
import { cn } from "../../lib/utils";

// Define button variants using a utility function for styling
const buttonVariants = {
  base: "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
  variants: {
    default: "bg-primary text-primary-foreground shadow hover:bg-primary/90",
    destructive:
      "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
    outline:
      "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
    secondary:
      "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
    ghost: "hover:bg-accent hover:text-accent-foreground",
    link: "text-primary underline-offset-4 hover:underline",
    main: "bg-primary text-primary-foreground shadow hover:bg-primary-buttonHover hover:text-gray-800",
  },
  sizes: {
    default: "h-9 px-4 py-2",
    sm: "h-8 rounded-md px-3 text-xs",
    lg: "h-10 rounded-md px-8 text-lg",
    icon: "h-9 w-9",
  },
  default: {
    variant: "default",
    size: "default",
  },
};

// Button component interface (not required in JSX, but conceptually the same)
const Button = React.forwardRef(function Button(
  { className, variant, size, asChild = false, ...props },
  ref
) {
  const Comp = asChild ? Slot : "button";
  return (
    <Comp
      className={cn(
        buttonVariants.base,
        buttonVariants.variants[variant || "default"],
        buttonVariants.sizes[size || "default"],
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Button.displayName = "Button";

// ShopButton component for the "Shop Now" button
export const ShopButton = ({ size }) => {
  return (
    <>
    <Button
      variant="default"
      size={size}
      className="hover:bg-primary-buttonHover hover:text-gray-800"
      >
      <FaCartShopping />
      &nbsp;&nbsp;Shop Now
    </Button>
   
    </>
  );
};

export { Button };
